import { defineComponent as _defineComponent } from 'vue'
import CcCardItem from '@/views/Automation/CampaignCreatorV2/components/CcCard/CcCardItem.ts.vue';
import CcDropdownInput from '@/views/Automation/CampaignCreatorV2/components/CcDropdown/CcDropdownInput.ts.vue';
import CcIcon from '@/views/Automation/CampaignCreatorV2/components/CcIcon/CcIcon.ts.vue';
import {
  defaultParameterOptions,
  defaultParameters,
  defaultUrl,
} from '@/views/Automation/CampaignCreatorV2/components/Modals/helpers';
import { CardLayer } from '@/views/Automation/CampaignCreatorV2/types';
import { computed, ref } from 'vue';

interface Props {
  url?: string;
  hasBaseUrl?: boolean;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CcBuildUrlParameterModal.ts',
  props: {
    url: { default: defaultUrl },
    hasBaseUrl: { type: Boolean, default: true }
  },
  emits: ["onSave"],
  setup(__props: any, { expose, emit: emits }: { emit: ((e: 'onSave', value: string) => void), expose: any, slots: any, attrs: any }) {

const props = __props as { url: string, hasBaseUrl: boolean };





const isModalOpen = ref(false);

const urlComponents = ref<{ baseURl: string; customParams: { key: string; value: string }[] }>({
  baseURl: '',
  customParams: [],
});

function getURL() {
  const url = new URL(urlComponents.value?.baseURl || defaultUrl);
  urlComponents.value?.customParams.forEach((param) => {
    url.searchParams.set(param.key, param.value);
  });
  return url;
}

const buildURL = computed(() => getURL());

const urlPreview = computed(() => {
  const url = buildURL?.value?.toString() ?? '';
  if (!props.hasBaseUrl) return decodeURIComponent(buildURL.value?.searchParams.toString());
  return decodeURI(url);
});

const customParams = computed(() => {
  const allSearchParams = buildURL.value?.searchParams;
  const customParamItems = Array.from(allSearchParams?.keys() || []).filter(
    (key) => !defaultParameters.find((param) => param.key === key)
  );
  return customParamItems.map((e) => ({ key: e, value: allSearchParams?.get(e) || '' }));
});

const baseUrl = computed(() => `${buildURL.value?.origin}${buildURL.value?.pathname}`);

const defaultParams = computed(() => {
  const defaults = defaultParameters.map((param) => {
    const value = buildURL.value?.searchParams?.get(param.key) || '';
    return { ...param, value };
  });
  return defaults;
});

function fromURLToComponents(url: URL) {
  const customParams = Array.from(url.searchParams.entries()).map(([key, value]) => ({ key, value }));
  return { baseURl: `${url.origin}${url.pathname}`, customParams };
}

function changeBaseUrl(value: string) {
  const newUrl = new URL(value);
  if (newUrl.origin) {
    urlComponents.value.baseURl = value;
  }
}

function getValidUrl(url: string) {
  const regex = /^https?:\/\/(?:[\w-]+\.)?[\w-]+\.[a-zA-Z]{2,}.*$/;
  let validUrl = url;

  if (!props.hasBaseUrl && !regex.test(validUrl)) {
    validUrl = defaultUrl + url;
  }
  return validUrl;
}

function onModalOpen() {
  const url = new URL(getValidUrl(props.url));
  urlComponents.value = fromURLToComponents(url);
  isModalOpen.value = true;
}

function onModalClose() {
  urlComponents.value = { baseURl: '', customParams: [] };
  isModalOpen.value = false;
}

function onCustomParameterAdd() {
  const url = getURL();
  url.searchParams.append('', '');
  urlComponents.value = fromURLToComponents(url);
}

function onParameterChange(value: string, key: string) {
  const url = getURL();
  url?.searchParams?.set(key, value);
  urlComponents.value = fromURLToComponents(url);
}

function changeKey(oldKey: string, newKey: string) {
  const url = getURL();
  const value = url.searchParams.get(oldKey) || '';
  url.searchParams.delete(oldKey);
  url.searchParams.set(newKey, value);
  urlComponents.value = fromURLToComponents(url);
}

function onRemoveCustomParam(key: string) {
  const url = getURL();
  url.searchParams?.delete(key);
  urlComponents.value = fromURLToComponents(url);
}

function onRemoveEmptyValueParams() {
  const url = getURL();
  url.searchParams.forEach((value, key) => {
    if (!value) {
      url.searchParams.delete(key);
    }
  });
  urlComponents.value = fromURLToComponents(url);
}

function onModalSave() {
  onRemoveEmptyValueParams();
  onRemoveCustomParam('');
  emits('onSave', urlPreview.value);
  onModalClose();
}

expose({ onModalOpen });

return { __sfc: true,props, emits, isModalOpen, urlComponents, getURL, buildURL, urlPreview, customParams, baseUrl, defaultParams, fromURLToComponents, changeBaseUrl, getValidUrl, onModalOpen, onModalClose, onCustomParameterAdd, onParameterChange, changeKey, onRemoveCustomParam, onRemoveEmptyValueParams, onModalSave, CcCardItem, CcDropdownInput, CcIcon, defaultParameterOptions, CardLayer }
}

})